import ProductContainerDetails from "@shared/filters/product_container_details.js";

const ProductInfo = function (product) {
  if (product == undefined) {
    return [];
  }

  var details = ProductContainerDetails()(product).split(" - ");
  return [details[0], DetailsSubtitle(details)];
};

const JoinedProductInfo = function (product) {
  if (product == undefined) {
    return [];
  }
  return ProductContainerDetails()(product, null, null, true);
};

const DetailsSubtitle = function (details) {
  if (!details[1]) {
    return "";
  }
  var subtitle = details[1];
  if (details[2]) {
    subtitle += " - " + details[2];
  }
  if (details[3]) {
    subtitle += " - " + details[3];
  }
  return subtitle;
};

export { ProductInfo, JoinedProductInfo };
